import { z } from 'zod';
import { StageNoteSchema, StageSchema } from '../../model';

export const CreateStageNoteResponseSchema = z.object({
  result: z.object({
    success: z.boolean(),
    error: z.string().nullable(),
    entity: StageNoteSchema.nullable(),
  }),
});

export const CreateStageNoteVariablesSchema = z.object({
  input: z.object({
    parentType: z.string(),
    stageId: z.string().uuid(),
    parentId: z.string().uuid(),
    content: z.string().min(3).max(500),
  }),
});

export const CompleteStageResponseSchema = z.object({
  result: z.object({
    entity: z.object({
      completed: StageSchema,
      next: StageSchema.nullable(),
    }),
    success: z.boolean(),
    error: z.string().nullable(),
  }),
});

export const CompleteStageVariablesSchema = z.object({
  input: z.object({
    parentType: z.string(),
    parentId: z.string().uuid(),
    stageId: z.string().uuid(),
  }),
  parentType: z.string(),
  parentId: z.string().uuid(),
});

export const UnCompleteStageResponseSchema = z.object({
  result: z.object({
    entity: z.object({
      unCompleted: StageSchema,
      previous: StageSchema.nullable(),
    }),
    success: z.boolean(),
    error: z.string().nullable(),
  }),
});

export const UnCompleteStageVariablesSchema = z.object({
  input: z.object({
    parentType: z.string(),
    stageId: z.string().uuid(),
    parentId: z.string().uuid(),
  }),
  parentType: z.string(),
  parentId: z.string().uuid(),
});

export const StageDocumentEntitySchema = z.object({
  id: z.string(),
});

export const UploadStageDocumentResponseSchema = z.object({
  result: z.object({
    success: z.boolean(),
    error: z.string().nullable(),
    entity: StageDocumentEntitySchema.nullable(),
  }),
});

export const UploadStageDocumentVariablesSchema = z.object({
  input: z.object({
    isPii: z.boolean(),
    docName: z.string(),
    parentType: z.string(),
    stageId: z.string().uuid(),
    parentId: z.string().uuid(),
    files: z.array(z.unknown()),
    attributeId: z.string().uuid(),
    availableForRoles: z.array(z.string()),
  }),
});

export const RemoveStageDocumentResponseSchema = z.object({
  result: z.object({
    success: z.boolean(),
    error: z.string().nullable(),
    entity: StageDocumentEntitySchema.nullable(),
  }),
});

export const RemoveStageDocumentVariablesSchema = z.object({
  input: z.object({
    id: z.string().uuid(),
  }),
});

export const StageDocumentFileSchema = z.object({
  id: z.string().uuid(),
  source: z.string().nullable(),
  docName: z.string().nullable(),
  createdDateTime: z.string().nullable(),
  createdBy: z
    .object({
      id: z.string().uuid(),
      fullName: z.string().nullable(),
    })
    .nullable(),
});

export const StageDocumentViewModelSchema = z.object({
  id: z.string().uuid(),
  attributeId: z.string().uuid(),
  availableForRoles: z.array(z.string()),
  documents: z.array(StageDocumentFileSchema),
});

export const GetStageAttributeDocumentsResponseSchema = z.object({
  result: z.object({
    success: z.boolean(),
    error: z.string().nullable(),
    list: z.array(StageDocumentViewModelSchema),
  }),
});

export const GetStageAttributeDocumentsVariablesSchema = z.object({
  input: z.object({
    parentType: z.string(),
    stageId: z.string().uuid(),
    parentId: z.string().uuid(),
  }),
});
